import { X, Star, ShoppingCart, Heart, GitCompare } from "lucide-react";
import { Link } from "react-router-dom";
import { productImageUrl } from "../lib/api";
import { useCart } from "../context/CartContext";
import { useFavorites, useCompare } from "../context/FavoritesCompareContext";
import { useCurrency } from "../context/CurrencyContext";
import { toast } from "sonner";

export default function QuickViewModal({ product, onClose }) {
  const { addItem } = useCart();
  const fav = useFavorites();
  const cmp = useCompare();
  const { format: formatGdes } = useCurrency();
  if (!product) return null;
  const discounted = product.is_promo && product.discount_percent > 0
    ? Math.round(product.price * (100 - product.discount_percent)) / 100
    : null;
  const oldPrice = product.compare_at_price && product.compare_at_price > product.price
    ? product.compare_at_price
    : (discounted ? product.price : null);
  const currentPrice = discounted != null ? discounted : product.price;
  const hasDiscount = oldPrice != null;
  return (
    <div className="fixed inset-0 z-[55] bg-black/60 flex items-center justify-center p-4" onClick={onClose} data-testid="quickview-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full overflow-hidden grid md:grid-cols-2" onClick={(e)=>e.stopPropagation()}>
        <div className="w-full" style={{ height: "360px" }}>
          <img src={productImageUrl(product.images?.[0])} alt={product.name} className="block w-full h-full object-cover" />
        </div>
        <div className="p-6 relative">
          <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"><X className="w-5 h-5" /></button>
          {product.brand && <span className="text-xs uppercase tracking-widest text-gray-500 font-bold">{product.brand}</span>}
          <h3 className="text-xl font-bold mt-1" style={{fontFamily:"Outfit"}}>{product.name}</h3>
          <div className="flex items-center gap-1 mt-2 text-sm">
            {Array.from({length:5}).map((_,i) => <Star key={i} className={`w-4 h-4 ${i < Math.round(product.rating) ? "je-star fill-current" : "text-gray-300"}`} />)}
            <span className="text-gray-500 ml-1">({product.reviews_count} avis)</span>
          </div>
          <div className="mt-3 flex items-baseline gap-2">
            {hasDiscount ? (
              <>
                <span className="text-2xl font-extrabold text-[#E3000F]" style={{fontFamily:"Outfit"}}>{formatGdes(currentPrice)}</span>
                <span className="text-sm text-gray-400 line-through">{formatGdes(oldPrice)}</span>
              </>
            ) : (
              <span className="text-2xl font-extrabold" style={{fontFamily:"Outfit"}}>{formatGdes(product.price)}</span>
            )}
          </div>
          <p className="mt-3 text-sm text-gray-600 line-clamp-4">{product.description}</p>
          <div className="mt-5 flex flex-wrap gap-2">
            <button onClick={() => { addItem(product, 1); toast.success("Ajouté au panier"); onClose(); }} className="je-btn-primary inline-flex items-center gap-1.5" data-testid="qv-add-cart"><ShoppingCart className="w-4 h-4" /> Ajouter au panier</button>
            <button onClick={() => fav.toggle(product.product_id)} className={`border rounded px-3 py-2 text-sm inline-flex items-center gap-1 ${fav.has(product.product_id) ? "bg-red-50 border-red-200 text-red-700" : ""}`}><Heart className={`w-4 h-4 ${fav.has(product.product_id) ? "fill-current" : ""}`} /></button>
            <button onClick={() => cmp.toggle(product.product_id)} className={`border rounded px-3 py-2 text-sm inline-flex items-center gap-1 ${cmp.has(product.product_id) ? "bg-blue-50 border-blue-200 text-[#0052CC]" : ""}`}><GitCompare className="w-4 h-4" /></button>
            <Link to={`/products/${product.product_id}`} onClick={onClose} className="border rounded px-3 py-2 text-sm font-semibold">Voir la fiche →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
